export const SectionLabel = ({ children, testId }) => (
  <div
    data-testid={testId}
    className="text-xs uppercase tracking-[0.3em] font-semibold text-[#282760]"
  >
    {children}
  </div>
);

export const SectionHeading = ({ eyebrow, title, sub, align = "left", testId }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <div className="text-xs uppercase tracking-[0.3em] font-semibold text-[#282760]">
        {eyebrow}
      </div>
    )}
    <h2
      data-testid={testId}
      className="mt-4 text-4xl sm:text-5xl tracking-tight leading-tight text-[#1A1B2E]"
      style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
    >
      {title}
    </h2>
    {sub && (
      <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#5B5E78]">
        {sub}
      </p>
    )}
  </div>
);
